import { itemsDemo } from './item';
import { usersDemo } from './user';
import { JackpotBet } from '@models/jackpot-bet.interface';
import { Jackpot } from '@models/jackpot.interface';

export function generateJackpotRound(finished = false): Jackpot {
  const bets = [];
  const betsCount = Math.floor(Math.random() * 20) + 1;
  for (let i = 0; i < betsCount; i++) {
    bets.push(generateBet());
  }

  return {
    gameid: Math.floor(Math.random() * 10000),
    hash: generateRandomHash(),
    potid: Math.floor(Math.random() * 10000),
    value: bets.reduce((acc, bet) => acc + bet.total_value, 0),
    start: Math.floor(Date.now() / 1000),
    status: finished ? 'ended' : 'active',
    winner: finished ? bets[Math.floor(Math.random() * bets.length)] : null,
    bets: bets,
    module: Math.random(),
    seed: generateRandomHash(),
    secret: generateRandomHash(),
  };
}

function generateRandomHash() {
  return Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
}

function generateUserColor() {
  const letters = '0123456789ABCDEF';
  let color = '#';
  for (let i = 0; i < 6; i++) {
    color += letters[Math.floor(Math.random() * 16)];
  }
  return color;
}

export function generateBet(): JackpotBet {
  const user = usersDemo[Math.floor(Math.random() * usersDemo.length)];
  const items = [];
  // get random number of items between 1 and 10 from itemsDemo
  const itemsCount = Math.floor(Math.random() * 10) + 1;
  for (let i = 0; i < itemsCount; i++) {
    items.push(itemsDemo[Math.floor(Math.random() * itemsDemo.length)]);
  }

  return {
    ...user,
    skins: items,
    user_color: generateUserColor(),
    total_value: items.reduce((acc, item) => acc + item.price, 0),
    chances: Math.random() * 100,
  };
}
